import { IS_WEB } from "@common/utils/mobileUtils"
import {
    openStoreUrl,
    resolveStoreUrl,
    storeHref,
    trackStoreClick,
    webStoresToShow,
} from "@common/utils/storeLinks"
import React from "react"
import { Image, TouchableOpacity, View } from "react-native"
import { connect } from "react-redux"
import appStore from "../../../assets/app-store-b.png"
import playStore from "../../../assets/google-play-b.png"

// Le lien `intent://` d'Android s'ouvre dans l'onglet : c'est l'application
// Play Store qui le prend, la page reste derrière.
const WebStoreLink = ({ url, source, width, height, marginTop, onClick }) => (
    <a
        href={url}
        {...(url.startsWith("intent:")
            ? {}
            : { target: "_blank", rel: "noopener noreferrer" })}
        onClick={onClick}
        style={{
            display: "block",
            marginTop,
            width,
            height,
            textDecoration: "none",
            cursor: "pointer",
        }}
    >
        <Image
            source={source}
            resizeMode="contain"
            style={{ width, height, pointerEvents: "none" }}
        />
    </a>
)

const DownloadAppButton = (props) => {
    const { trackingSource } = props
    const storeUrls = {
        iosAppUrl: props?.iosAppUrl,
        androidAppUrl: props?.androidAppUrl,
    }
    const iosUrl = resolveStoreUrl("ios", storeUrls)
    const androidUrl = resolveStoreUrl("android", storeUrls)
    if (IS_WEB) {
        const stores = webStoresToShow()
        return (
            <View>
                {stores.includes("ios") && (
                    <WebStoreLink
                        url={iosUrl}
                        source={appStore}
                        width={200}
                        height={(200 * 162) / 512}
                        marginTop={30}
                        onClick={() => trackStoreClick("ios", trackingSource)}
                    />
                )}
                {stores.includes("android") && (
                    <WebStoreLink
                        url={storeHref("android", androidUrl)}
                        source={playStore}
                        width={200}
                        height={(200 * 250) / 646}
                        marginTop={stores.length > 1 ? 10 : 30}
                        onClick={() =>
                            trackStoreClick("android", trackingSource)
                        }
                    />
                )}
            </View>
        )
    }
    return (
        <View style={{}}>
            <TouchableOpacity
                style={{ marginTop: 30 }}
                onPress={() => {
                    trackStoreClick("ios", trackingSource)
                    openStoreUrl(iosUrl)
                }}
            >
                <Image
                    style={{ width: 200, height: (200 * 162) / 512 }}
                    resizeMode="contain"
                    source={appStore}
                />
            </TouchableOpacity>
            <TouchableOpacity
                style={{ marginTop: 10 }}
                onPress={() => {
                    trackStoreClick("android", trackingSource)
                    openStoreUrl(androidUrl)
                }}
            >
                <Image
                    style={{ width: 200, height: (200 * 250) / 646 }}
                    resizeMode="contain"
                    source={playStore}
                />
            </TouchableOpacity>
        </View>
    )
}
const mapStateToProps = (state) => {
    return {
        androidAppUrl: state.data.staticData?.android_app_url,
        iosAppUrl: state.data.staticData?.ios_app_url,
    }
}

export default connect(mapStateToProps)(DownloadAppButton)
